module.exports = __webpack_public_path__ + "media/files/sample_eligibility_file-b1a3636fb0d17f05b63e0646f8298447.csv";